import React from 'react';
import { Base } from '@stepstone-genesis/components';
import Jobfeed from 'modules/hub/components/Jobfeed/Jobfeed';
const OpenPositionsSection = ({ data }) => {
    if (!data.items.length)
        return null;
    return (React.createElement(Base, { "data-testid": "section-open-positions" },
        React.createElement(Jobfeed, { jobs: data.items })));
};
export default OpenPositionsSection;
